import axios from "axios";
import authHeader from "./auth-header";

/**
 * Récupère l'identifiant de la racine Confluence (endpoint /root).
 * Utilisé par la navigation (Work.jsx, useNavigation.js).
 *
 * NB : la gestion de la configuration runtime (Splunk, Jira, Confluence, LDAP,
 * rôles…) est désormais assurée par settings.service.js + l'écran
 * Administration › Configuration (table cv_settings). Les anciens endpoints
 * /configs (getConfigs/postConfig) ont été retirés.
 */
class ConfigService {
  getRoot() {
    return axios.get(process.env.REACT_APP_API_URL + "root", {
      headers: authHeader(),
    });
  }
}

export default new ConfigService();
